import React from 'react'
import Button from 'react-bootstrap/lib/Button'
import ButtonGroup from 'react-bootstrap/lib/ButtonGroup'
import OverlayTrigger from 'react-bootstrap/lib/OverlayTrigger'
import Tooltip from 'react-bootstrap/lib/Tooltip'
import Tag, { NoTags } from './tag'
import RunningTime from './running_time'
import { over8hours } from '../util/time_utils'
import { updateElectronDuration } from '../util/electron_ipc'

const TimerTags = ({entryTagIds, tags, teams}) => {
    const firstTwoTagIds = entryTagIds.slice(0, 2)
    const remainingTagIds = entryTagIds.slice(2)

    return entryTagIds.length === 0
        ? <NoTags />
        : <div className="timer-tags">{firstTwoTagIds.map(id =>
            <Tag {...tags.items[id]} key={id} teams={teams} />
        )} {remainingTagIds.length > 0 ? `+${remainingTagIds.length}` : ''}</div>
}

const Timer = ({
    editTimeEntry,
    stopTimeEntry,
    newTimeEntry,
    tags,
    teams,
    timeEntries,
    profile,
    runningTimeEntries,
    startAt,
    isMobile,
}) => {

    const profileId = profile.id
    const allRunningEntries = runningTimeEntries || {}
    const runningEntryIds = profileId ? (allRunningEntries[profileId] || []) : []
    const runningEntries = runningEntryIds
        .map(id => timeEntries.items[id])
        .filter(r => !!r)

    // just render timer for last running entry
    const runningEntry = runningEntries.length > 0 ? runningEntries[runningEntries.length-1] : {}

    const onEdit = () => editTimeEntry(runningEntry.id)
    const onStop = () => stopTimeEntry(runningEntry)
    
    const warningLength = runningEntry ? over8hours(runningEntry.startAt) : false
    const currentTimeClass = warningLength ? "current-time-over-8" : "current-time"
    const stopTimerButton = (
        <Button className="btn-stop-timer" onClick={isMobile ? onEdit : onStop} >
            <div className={currentTimeClass}>
                <RunningTime startAt={runningEntry.startAt} />
                <div className="stop">
                    <i className="fa fa-stop" aria-hidden="true" />
                    STOP
                </div>
            </div>
        </Button>
    )

    if (!(runningEntry && runningEntry.id)) {
        // send it
        updateElectronDuration(0, false)
    }

    return (
        <span>
            { runningEntry && runningEntry.id ?
                <ButtonGroup className="timer">
                    <OverlayTrigger placement="bottom" delayShow={300} delayHide={150} overlay={<Tooltip id="tip-edit-details">View &amp; edit details</Tooltip>}>
                        <Button className="btn-edit-timer" onClick={onEdit}>
                            <i className="fa fa-clock-o" aria-hidden="true" />
                            <TimerTags
                                entryTagIds={runningEntry.tags}
                                tags={tags}
                                teams={teams}
                            />
                        </Button>
                    </OverlayTrigger>
                    {!isMobile ? (
                        <OverlayTrigger placement="bottom" delayShow={300} delayHide={150} overlay={<Tooltip id="tip-stop-timer">Stop timer</Tooltip>}>
                            {stopTimerButton}
                        </OverlayTrigger>)
                        : stopTimerButton}
                </ButtonGroup>
                :
                <button onClick={newTimeEntry} className="btn btn-default btn-start-timer">
                    <i className="fa fa-clock-o" aria-hidden="true" /> Start Timer
                </button>
            }
        </span>
    )
}

export default Timer


// WEBPACK FOOTER //
// ./src/components/timer.jsx